// src/components/TokenLogo.tsx
import React from 'react';
import { getTokenLogo } from '@/constants/tokenLogos';
import { cn } from '@/lib/utils';

interface TokenLogoProps {
  symbol: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const sizeMap = {
  sm: 'w-6 h-6',
  md: 'w-8 h-8',
  lg: 'w-10 h-10',
  xl: 'w-12 h-12',
};

export const TokenLogo: React.FC<TokenLogoProps> = ({ 
  symbol, 
  size = 'md', 
  className 
}) => {
  const logoUrl = getTokenLogo(symbol.toUpperCase());
  const sizeClass = sizeMap[size] || sizeMap.md;
  
  return (
    <img
      src={logoUrl}
      alt={`${symbol} logo`}
      className={cn(
        'rounded-full object-contain bg-muted/30',
        sizeClass,
        className
      )}
      onError={(e) => {
        // Fallback to default if image fails to load
        (e.target as HTMLImageElement).src = '/tokens/default.png';
      }}
    />
  );
};
